if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      customFormData = null;
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-drawer") ||
          document.querySelector("cart-notification");
        this.submitButton = this.querySelector('[type="submit"]');
        this.isConsignmentProduct = this.dataset.consignment === "true";
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.dataset.hasAddons === "true") {
          return;
        }
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading__spinner").classList.remove("hidden");

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = this.customFormData || new FormData(this.form);

        if (
          this.isConsignmentProduct &&
          !formData.get("properties[_consignment]")
        ) {
          formData.append("properties[_consignment]", "true");
        }

        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id),
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (!response.id) {
              response["id"] = this.querySelector(".product-variant-id").value;

              const variantSelector = document.querySelector("variant-selects");
              if (variantSelector) {
                variantSelector.checkIfVariantIsInCart();
                variantSelector.checkIfAllVariantsAreInTheCart();
              }
              const atc = this.querySelector(
                ".product-form__submit[data-has-addons]",
              );
              if (atc) {
                atc.dataset.hasAddons = true;
              }
            }
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (!this.cart) {
              return;
            }

            if (!this.error) {
              const jsonObject = {};
              for (const [key, value] of formData.entries()) {
                jsonObject[key] = value;
              }
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: formData.get("id"),
                cartData: response,
                sectionId: this.closest("section").getAttribute("id"),
                formData: jsonObject,
              });
            }
            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true },
              );
              quickAddModal.hide(true);
            } else {
              // let responseToReturn = response;
              const variantSelector = document.querySelector("variant-selects");
              if (variantSelector) {
                variantSelector.checkIfVariantIsInCart();
                variantSelector.checkIfAllVariantsAreInTheCart();
              }

              // Always show cart notification first for immediate feedback
              if (this.cart) {
                this.cart.renderContents(response);
              }

              // Only show popup promotion if it exists and has actual content
              const popupPromoSection = document.querySelector(
                "popup-cart-promotion-section",
              );
              if (
                popupPromoSection &&
                popupPromoSection.querySelector(".popup-bottom")
              ) {
                try {
                  // Small delay to let cart notification show first
                  setTimeout(() => {
                    popupPromoSection.show();
                  }, 1000);
                } catch (error) {
                  console.error("Error showing popup promotion:", error);
                }
              }
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading__spinner").classList.add("hidden");
          });
      }
      async fetchCart() {
        try {
          const response = await fetch(`${window.Shopify.routes.root}cart.js`);
          if (!response.ok) {
            throw new Error(
              `Network response was not ok (status: ${response.status})`,
            );
          }
          const data = await response.json();
          return data;
        } catch (error) {
          console.error("Error fetching cart:", error);
          // depending on your needs, you can either:
          // 1) re-throw to let the caller handle it
          throw error;
          // 2) or return null/undefined: return null;
        }
      }

      getBundleProductData() {
        // 1. Select the <script> by its ID
        const scriptTag = document.getElementById("bundle-product-data");
        if (!scriptTag) {
          throw new Error("Bundle product data script tag not found");
        }

        // 2. Read its text content (the raw JSON)
        const jsonString = scriptTag.textContent || scriptTag.innerText;
        if (!jsonString) {
          throw new Error("Bundle product data is empty");
        }

        // 3. Parse and return
        return JSON.parse(jsonString);
      }
      async addToCart() {
        let bundleData;
        try {
          bundleData = this.getBundleProductData();
        } catch (error) {
          console.error("Unable to read bundle data:", error);
        }
        if (!bundleData || !bundleData.bundle_variants) {
          console.error("Invalid bundle data");
          return;
        }
        const variantsToAddIds = String(bundleData.bundle_variants).split(",");
        const variantsToAdd = variantsToAddIds.map((id) => ({
          id,
          quantity: 1,
          properties: {
            "_bundle-item": "true",
            ...(this.isConsignmentProduct ? { _consignment: "true" } : {}),
          },
        }));

        const formDataJSON = {
          items: variantsToAdd,
        };
        this.setCustomFormData(formDataJSON);
        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = this.customFormData || new FormData(this.form);

        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id),
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        const response = await fetch(`${routes.cart_add_url}`, config);
        if (!response.ok) {
          alert(
            "ERROR when adding the product cart! Please refresh page and try again",
          );
          return;
        }
        const data = await response.json();

        if (!data.id) {
          data["id"] = String(variantsToAdd[0].id);
        }

        if (this.cart) {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: "product-form",
            productVariantId: data.id,
            cartData: data,
            sectionId: this.closest("section")?.getAttribute("id"),
          });
          this.cart.renderContents(data);
        } else {
          console.error(
            "SecondShop Debug: this.cart is null for bundle! Redirecting...",
          );
        }
      }

      setCustomFormData(formData) {
        if (formData instanceof FormData) this.customFormData = formData;
        else {
          this.customFormData = new FormData();
          formData.items.forEach((item, index) => {
            this.customFormData.append(`items[${index}][id]`, item.id);
            this.customFormData.append(
              `items[${index}][quantity]`,
              item.quantity,
            );

            if (item.properties) {
              for (const prop in item.properties) {
                if (item.properties.hasOwnProperty(prop)) {
                  this.customFormData.append(
                    `items[${index}][properties][${prop}]`,
                    item.properties[prop],
                  );
                }
              }
            }
            if (this.isConsignmentProduct && !item.properties?._consignment) {
              this.customFormData.append(
                `items[${index}][properties][_consignment]`,
                "true",
              );
            }
          });
        }
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message",
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    },
  );
}
